import React, { useEffect, useState } from 'react';
import {Drawer, Table} from 'antd';

import AddSetupDetails from 'modules/system_setup/add_system_setup_values/addSetupDetails';

const columns = [
    {
        title: "ACCESS TYPE CODE",
        dataIndex: "access_type_code",
        key: "access_type_code",
        width: "15%"
    },
    {
        title: "ACCESS TYPE NAME",
        dataIndex: "access_type_name",
        key: "access_type_name",
        width: "20%"
    },
    {
        title: "DESCTIPTION",
        dataIndex: "access_type_desc",
        key: "access_type_desc",
        width: "40%"
    },
    {
        title: "DATE CREATED",
        dataIndex: "formatted_date",
        key: "formatted_date",
        width: "15%"
    },
    {
        title: "STATUS",
        dataIndex: "status",
        key: "status",
        width: "10%"
    },
];

function SearchAccessTypesTable(props) {
    const { data, pageSize } = props;
    const [tableData, setTableData] = useState([]);
    const [tableValues, setTableValues] = useState(data);

    const [open, setOpen] = useState(false);
    const showDrawer = () => { setOpen(true); };

    const onClose = () => { 
        setOpen(false); 
        // setTableData([]);
    };

    useEffect(()=> {
        setTableValues(data);
    }, [data])

    function setData(values) {
        setTableValues(values);
    }

    function refreshTblData(values) {
        console.log('check vat refresh', values)
    }

    function updateDrawer(e) {
        setTableData(e)
        showDrawer();
    }

    function drawerClose(value) {
        setOpen(value);
    }

    return(
        <div>
            <Table
                style={ {textTransform: "uppercase"} }
                dataSource = {tableValues}
                columns={columns}
                bordered
                pagination={{ defaultPageSize: 5 }}
                onRow={(record) => {
                    return {
                        onDoubleClick: (e) => {updateDrawer(record)}
                    };
                }}
            />
            <Drawer title={"UPDATE " + props.setupValue} placement="right" onClose={onClose}
                width="30%"
                visible={open}
            >
                <AddSetupDetails 
                    setupDet={props.setupValue} 
                    drawerClose={ drawerClose }
                    refreshTblData={ refreshTblData }
                    tableData={ tableData }
                    setData={ setData }
                />
            </Drawer>
        </div>
    )
}

export default SearchAccessTypesTable;